<template>
  <div class="w-full full-login font-poppins">
    <div class="block sm:flex justify-center align-items-center">
      <form @submit.prevent="signInSession" class="xl:h-auto flex">
        <div
          class="my-4 mx-4 px-4 py-8 bg-white rounded-md sm:w-11/12 w-full"
          style="box-shadow: 0px 4px 50px 0px #00000026"
        >
          <img
            v-if="urlOriginIsBrandIn"
            alt="COTIZADOR"
            class="-intro-x -mt-16"
            style="display: block; margin: auto; width: 200px"
            :src="require(`@/assets/images/COT-img/logo-brand-in.png`)"
          />
          <img
            v-else
            alt="COTIZADOR"
            class="-intro-x -mt-16"
            style="display: block; margin: auto; width: 200px"
            :src="require(`@/assets/images/COT-img/logo.png`)"
          />
          <div class="intro-x mt-8 px-8">
            <div class="intro-x text-theme-2 text-center text-base">
              Ingresa tus credenciales de Brand In para accesar
            </div>
          </div>
          <div class="intro-x mt-2 px-8">
            <div class="intro-x text-theme-2 text-left">Correo</div>
            <input
              type="email"
              class="intro-x form-control py-3 px-4 border-theme-3 block mb-2 text-base"
              v-model="email"
              placeholder="Correo"
              required
            />
            <div class="intro-x text-theme-2 text-left">Contraseña</div>
            <div class="input-group mt-1">
              <input
                :type="inputPasswordShow ? 'text' : 'password'"
                class="intro-x form-control py-3 px-4 border-theme-3 text-base"
                placeholder="Contraseña"
                style="
                  border-right-width: 0;
                  border-top-right-radius: 0;
                  border-bottom-right-radius: 0;
                "
                ref="password"
                v-model="password"
                required
              />
              <div
                class="input-group-text flex cursor-pointer"
                style="
                  border-left-width: 0;
                  background: transparent;
                  border-color: rgba(202, 202, 202, var(--tw-border-opacity));
                "
                @click="showPasswordChange"
              >
                <EyeIcon class="w-4 h-4 my-auto" v-if="!inputPasswordShow" />
                <EyeOffIcon class="w-4 h-4 my-auto" v-else />
              </div>
            </div>
          </div>
          <div class="intro-x mt-5 xl:mt-8 text-center px-8">
            <button
              type="submit"
              :disabled="!validateData"
              class="btn btn-quotation-login text-base py-3 px-4 w-60 border-0"
            >
              Entrar
            </button>
          </div>
          <div
            class="intro-x mt-10 text-theme-4 text-center text-base mx-8 pb-4"
            style="border-bottom: 1px solid rgba(196, 196, 196, 1)"
          >
            <router-link :to="{ name: 'recovery' }" tag="a">
              Olvidé mi contraseña
            </router-link>
          </div>
          <div class="intro-x mt-4 text-theme-4 text-center text-base">
            <router-link :to="{ name: 'activate' }" tag="a">
              Activar mi cuenta
            </router-link>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<style scoped>
.full-login {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  justify-content: center;
  /* background: url('@/assets/images/COT-bg/geometrialogin.png') no-repeat;
  background-size: cover;
  background-position: center; */
}

.form-check-input {
  width: 24px !important;
  height: 24px !important;
}
.form-check-input[type='checkbox']:checked {
  background: #faa306 !important;
  border: 1px solid #faa306;
}
</style>

<script>
import { getFirstErrorMessage } from '@/utils/tools'

export default {
  data() {
    return {
      email: '',
      password: '',
      inputPasswordShow: false
    }
  },
  beforeMount() {
    cash('html').addClass('unauthenticated')
    const accountActivate = this.$store.state?.main?.accountActivate
    const otpResetPassword = this.$store.state?.main?.otpResetPassword
    const otpResetPasswordSuccess =
      this.$store.state?.main?.otpResetPasswordSuccess
    if (accountActivate) {
      this.$toast.success(accountActivate, {
        position: 'top'
      })
      this.$store.commit('main/setAccountActivate', undefined)
    } else if (otpResetPassword) {
      this.$toast.error(otpResetPassword, {
        position: 'top'
      })
      this.$store.commit('main/setOtpResetPassword', undefined)
    } else if (otpResetPasswordSuccess) {
      this.$toast.success(otpResetPasswordSuccess, {
        position: 'top'
      })
      this.$store.commit('main/setOtpResetPasswordSuccess', undefined)
    }
  },
  methods: {
    async signInSession() {
      this.$store.commit('main/setShowSpinner', true)
      try {
        const response = await this.axios.post('/auth/sign-in-sales-operator', {
          email: this.email,
          password: this.password
        })
        this.$store.commit('auth/setSessionData', {
          token: response.data.authorization.access_token,
          user: response.data.user,
          company: response.data.company
        })
        this.$router.push('/')
      } catch (error) {
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
      }
    },
    showPasswordChange() {
      this.inputPasswordShow = !this.inputPasswordShow
      this.$refs.password.focus()
      setTimeout(() => {
        const length = this.$refs.password.value.length
        this.$refs.password.setSelectionRange(length, length)
      })
    }
  },
  computed: {
    validateData() {
      return this.email && this.validateEmail && this.password?.length >= 8
    },
    validateEmail() {
      const re = /\S+@\S+\.\S+/
      return re.test(this.email || '')
    },
    urlOriginIsBrandIn() {
      const currentHost = (window.location?.host || '').replace(/^www\./, '')
      const brandInDomain = (process.env.VUE_APP_BRAND_IN_DOMAIN || '').replace(
        /^www\./,
        ''
      )
      return currentHost === brandInDomain
    }
  }
}
</script>
